import React from 'react';
import { BlankModal, ModalBody, ModalFooter, ModalHeader, Button } from '@cad-arc';
import { useFullscreenModalControls } from '../modals/context/modal-context-provider';
import { ManageWorkspaceList } from './manage-workspace-list';
import { WorkspaceTemplateOption } from '@mark43/cad-api';

export type ManageUserWorkspacesModalComponentType = typeof ManageUserWorkspacesModal;
export function ManageUserWorkspacesModal(props: {
    workspaceOptions: WorkspaceTemplateOption[];
}): React.ReactElement {
    const [localWorkspaceOptions, setLocalWorkspaceOptions] = React.useState<
        WorkspaceTemplateOption[]
    >(props.workspaceOptions);
    const modalControls = useFullscreenModalControls();
    const onClose = React.useCallback(() => {
        modalControls.close();
    }, [modalControls]);

    return (
        <BlankModal size="lg" onClose={onClose} isOpen={true}>
            <ModalHeader>Manage My Workspaces</ModalHeader>
            <ModalBody>
                <ManageWorkspaceList
                    workspaceOptions={localWorkspaceOptions}
                    setWorkspaceOptions={setLocalWorkspaceOptions}
                    workspaceTemplateType="USER"
                />
            </ModalBody>
            <ModalFooter>
                <Button onClick={onClose} variant="ghost">
                    Close
                </Button>
            </ModalFooter>
        </BlankModal>
    );
}
